<div class="content-holder" *transloco="let t; scope: 'profile'">
  <div class="header align-items-center">
    <p class="title">
      <span>{{ t('navigation.bio') }}</span>
    </p>
      <span class="badge badge-warning text-dark align-self-center" [style.opacity]="hasUnsavedChanges() ? 1 : 0" style="transition: opacity 0.3s ease-in-out;">
        {{ t('content_management.unsaved_changes') }}
      </span>

    @if (subtitle()) {
      <div class="subtitle">{{ subtitle() }}</div>
    }
  </div>

  <div class="row body">
    <div class="col-12 mt-4">
      @if (error()) {
        <alert [type]="'danger'" [dismissible]="true" class="mb-4">
          <span [innerHTML]="t(error()!)"></span>
        </alert>
      }

      @if (initialLoading()) {
        <div class="d-flex justify-content-center py-4">
          <multisite-loader-globe-animation-detail [width]="80" [height]="80" class="my-3"></multisite-loader-globe-animation-detail>
        </div>
      } @else {
        <form [formGroup]="bioForm" role="form" class="w-100" (ngSubmit)="saveProfile()">
          <div class="input-self">
            <label for="job_title" class="form-label">
              {{ t('profile.title') }}
            </label>
            <input
              id="job_title"
              type="text"
              class="form-control input-lg"
              formControlName="job_title"
            />
            <div class="form-text text-muted">
              {{ t('profile.title_help') }}
            </div>
            <cco-common-form-validation-messages
              [control]="bioForm.controls.job_title"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <label for="summary" class="form-label">
              {{ t('profile.summary') }}
            </label>
            <textarea
              id="summary"
              class="form-control input-lg"
              formControlName="summary"
              rows="2"
            ></textarea>
            <div class="form-text text-muted">
              {{ t('profile.summary_help') }}
            </div>
            <cco-common-form-validation-messages
              [control]="bioForm.controls.summary"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <label for="bio" class="form-label">
              {{ t('navigation.bio') }}
            </label>
            <textarea
              id="bio"
              class="form-control input-lg"
              formControlName="bio"
              rows="8"
            ></textarea>
            <div class="form-text text-muted">
              {{ t('profile.bio_help') }}
            </div>
            <cco-common-form-validation-messages
              [control]="bioForm.controls.bio"
              [showErrors]="submitAttempted()"
            ></cco-common-form-validation-messages>
          </div>

          <div class="input-self">
            <div class="input-group my-3">
              @if (isAnythingLoading()) {
                <div class="d-flex justify-content-center w-100">
                  <multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail>
                </div>
              } @else {
                <button
                  class="btn btn-lg btn-primary w-100"
                  type="submit"
                  [disabled]="bioForm.invalid || formDisabled()"
                >
                  {{ t('common.save_changes') }}
                </button>
              }
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
